const PMChartDeadlinesPage = () => import('@/pages/ProjectManagement/PMChartDeadlinesPage.vue');
const PMReportConsolidated = () => import('@/pages/ProjectManagement/PMReportConsolidated.vue');
const ReportConstruction = () => import('@/pages/ProjectManagement/ReportConstruction.vue');
const PMReportDpcExec = () => import('@/pages/ProjectManagement/PMReportDpcExec.vue');
const PMReports = () => import('@/pages/ProjectManagement/PMReports.vue');
export default [
    {
        path: 'reports',
        name: 'projectManagement.reports',
        component: PMReports,
        meta: { showSidebar: true },
    },
    {
        path: 'report/dpc-exec',
        name: 'projectManagement.report.dpcExec',
        component: PMReportDpcExec,
        meta: {},
    },
    {
        name: 'projectManagement.report.construction',
        path: 'report/construction',
        component: ReportConstruction,
        meta: {},
    },
    {
        name: 'projectManagement.report.deadlines',
        path: 'report/deadlines',
        component: PMChartDeadlinesPage,
        meta: {},
    },
    {
        name: 'projectManagement.report.consolidated',
        path: 'report/consolidated',
        component: PMReportConsolidated,
        meta: {},
    },
];
